export default __webpack_public_path__ + "static/media/project1.8a8deff8.PNG";